(() => {
  if (window.ovrzeWinterReady) return;
  window.ovrzeWinterReady = true;
  const routeRoot = () => window.Shopify?.routes?.root || '/';
  const drawerElement = () => document.querySelector('ow-cart-drawer');
  const drawerDialog = () => drawerElement()?.querySelector('dialog');
  let cartPending = false;
  let cartOpener = null;

  function openDrawer() {
    const dialog = drawerDialog();
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) dialog.showModal();
    return true;
  }

  function replaceDrawer(html, count) {
    if (!html) return false;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const next = documentFragment.querySelector('ow-cart-drawer');
    const existing = drawerElement();
    if (!next || !existing) return false;
    drawerDialog()?.close();
    existing.replaceWith(next);
    if (typeof count === 'number') document.querySelectorAll('.oc-cart-count').forEach(el => { el.textContent = String(count); });
    return openDrawer();
  }

  async function renderCart() {
    const drawer = drawerElement();
    if (!drawer) return false;
    const sectionId = drawer.dataset.sectionId;
    const query = new URL(routeRoot(), window.location.origin);
    query.searchParams.set('section_id', sectionId);
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(query.toString(), { credentials: 'same-origin' }),
      fetch(routeRoot() + 'cart.js', { credentials: 'same-origin' })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error(drawer.dataset.addError);
    const [html, cart] = await Promise.all([sectionResponse.text(), cartResponse.json()]);
    return replaceDrawer(html, cart.item_count);
  }

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented || !form.action.includes('/cart/add') || !drawerElement() || !form.reportValidity()) return;
    const productElement = form.closest('ovrze-decision-product');
    if (productElement && productElement.sizeChosen === false) return;
    event.preventDefault();
    if (cartPending) return;
    cartPending = true;
    cartOpener = form.querySelector('button[type="submit"]');
    const button = cartOpener;
    const status = form.querySelector('.ow-form-status, [data-variant-status]');
    const originalDisabled = button?.disabled;
    if (button) button.disabled = true;
    if (status) status.textContent = drawerElement().dataset.adding;
    try {
      const data = new FormData(form);
      data.set('sections', drawerElement().dataset.sectionId);
      data.set('sections_url', window.location.pathname);
      const response = await fetch(routeRoot() + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || drawerElement().dataset.addError);
      const sectionId = drawerElement().dataset.sectionId;
      const html = result.sections?.[sectionId];
      const cartResponse = await fetch(routeRoot() + 'cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error(drawerElement().dataset.addError);
      const cart = await cartResponse.json();
      if (!replaceDrawer(html, cart.item_count) && !await renderCart()) window.location.assign(routeRoot() + 'cart');
      if (status) status.textContent = '';
    } catch (error) {
      if (status) status.textContent = error.message || drawerElement()?.dataset.addError;
      else window.location.assign(routeRoot() + 'cart');
    } finally {
      if (button) button.disabled = originalDisabled;
      cartPending = false;
    }
  });

  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const filter = target.closest('[data-winter-filter]');
    if (filter) {
      const section = filter.closest('[data-winter-list]');
      section.querySelectorAll('[data-winter-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      let shown = 0;
      section.querySelectorAll('[data-winter-kind]').forEach(item => {
        item.hidden = filter.dataset.winterFilter !== 'all' && item.dataset.winterKind !== filter.dataset.winterFilter;
        if (!item.hidden) shown += 1;
      });
      section.querySelector('[data-winter-empty]').hidden = shown !== 0;
    }
    if (target.closest('[data-drawer-close]')) {
      drawerDialog()?.close();
      cartOpener?.focus();
    }
    const cartLink = target.closest('.oc-header-actions a');
    if (cartLink && new URL(cartLink.href).pathname.endsWith('/cart') && drawerElement() && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      cartOpener = cartLink;
      try { if (!await renderCart()) window.location.assign(cartLink.href); }
      catch { window.location.assign(cartLink.href); }
    }
    const quantity = target.closest('[data-cart-key]');
    if (quantity && !cartPending) {
      event.preventDefault();
      cartPending = true;
      drawerDialog().setAttribute('aria-busy','true');
      try {
        const sectionId = drawerElement().dataset.sectionId;
        const response = await fetch(routeRoot() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ id:quantity.dataset.cartKey, quantity:Number(quantity.dataset.cartQuantity), sections:[sectionId], sections_url:window.location.pathname }) });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || cart.message || drawerElement().dataset.addError);
        if (!replaceDrawer(cart.sections?.[sectionId], cart.item_count)) await renderCart();
      } catch (error) {
        const status = drawerElement().querySelector('.ow-drawer-error');
        status.hidden = false;
        status.textContent = error.message || drawerElement().dataset.addError;
      } finally {
        drawerDialog()?.removeAttribute('aria-busy');
        cartPending = false;
      }
    }
    if (target.matches('.ow-cart-dialog')) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
    }
  });
})();
